<template>
    <div class="rm-files__group v-list__group">
        <div class="rm-files__filebox">
            <a href="#" @click.prevent="download()" class="rm-files__filename r-link" v-html="attachment.name"></a>
        </div>
        <button v-if="attachment.user_id == user.id" @click="deleteFile(attachment.id)" class="rm-files__delete button-icon button-delete r-button">
            <span class="screen-reader">Удалить</span>
        </button>
    </div>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex';

    export default {
        name: 'Attachment',
        props: {
            attachment: {
                type: Object,
                required: true
            }
        },
        computed: {
            ...mapState(['consultation']),
            ...mapState(['user']),
        },
        methods: {
            ...mapActions('attachment', [
                'deleteAttachment',
            ]),
            deleteFile(id) {
                this.deleteAttachment(id);
            },
            download() {
                const type = this.attachment.name.split(".").pop();

                if (['pdf', 'png', 'jpeg', 'jpg', 'doc', 'docx'].indexOf(type) !== -1) {
                    if (['png', 'jpeg', 'jpg'].indexOf(type) !== -1) {
                        let newWindow  = window.open('/storage/room/' + this.attachment.path, 'Show', "width=700,height=600,left=200,top=50;");
                    } else {
                        window.open('/attachments/show/' + this.attachment.id + '/' + this.attachment.name, 'Show', "width=700,height=600,left=200,top=50;");
                    }
                }
                else {
                    window.open('/attachments/download/' + this.attachment.id, 'Download');
                }
            }
        },
    }
</script>
